'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentSezzleAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.20801 31.1079C8.81865 32.7399 11.4241 32.7399 13.0229 31.1079L13.1769 30.9519C13.9822 30.1359 12.3715 25.8639 13.1769 25.0599L7.20801 31.1079Z",
          fill: "url(#paint0_linear_647_1977)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3308 24.892L13.1769 25.048C12.3716 25.864 13.9822 30.136 13.1769 30.94L19.1457 24.892C18.3404 24.076 17.2864 23.668 16.2324 23.668C15.1902 23.668 14.1362 24.076 13.3308 24.892Z",
          fill: "url(#paint1_linear_647_1977)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.20798 25.204C5.59734 26.836 5.59734 29.476 7.20798 31.096L13.3308 24.892C14.9414 23.26 14.9414 20.62 13.3308 19L7.20798 25.204Z",
          fill: "url(#paint2_linear_647_1977)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.0229 31.1081C11.4122 32.7401 11.4122 35.3801 13.0229 37.0001L19.1457 30.7961C20.7563 29.1641 20.7563 26.5241 19.1457 24.9041L13.0229 31.1081Z",
          fill: "url(#paint3_linear_647_1977)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M42.9973 28.036C42.8789 27.604 42.6894 27.196 42.4526 26.824C42.0381 26.176 41.4696 25.636 40.7946 25.264C39.7287 24.676 38.4615 24.544 37.3009 24.88C36.1166 25.228 35.1455 26.02 34.5652 27.112C33.9849 28.204 33.8427 29.452 34.1862 30.64V30.652C34.2691 30.916 34.3875 31.252 34.3875 31.264C34.7783 32.188 35.4297 32.896 36.389 33.424C37.064 33.796 37.822 34 38.5799 34C39.0181 34 39.4563 33.94 39.8826 33.808C40.7827 33.544 41.5643 33.016 42.1565 32.284L42.192 32.236C42.346 32.044 42.4763 31.84 42.5947 31.624C42.8079 31.24 42.6657 30.76 42.2986 30.544C42.1802 30.484 42.0499 30.448 41.9196 30.448C41.6354 30.448 41.3749 30.604 41.2327 30.856C41.0433 31.204 40.7827 31.516 40.4748 31.756C40.4511 31.78 40.4274 31.804 40.4037 31.816C40.1195 32.032 39.7879 32.2 39.4445 32.296C38.6747 32.524 37.8457 32.428 37.1351 32.044C36.6732 31.792 36.2824 31.408 35.9982 30.94L42.4644 29.02C42.8789 28.888 43.1158 28.444 42.9973 28.036ZM38.5918 26.26C39.0892 26.26 39.5984 26.392 40.0366 26.632C40.4748 26.872 40.8538 27.232 41.138 27.664C41.1498 27.688 41.1735 27.712 41.1854 27.736L35.5481 29.416C35.5363 28.876 35.6666 28.336 35.9153 27.868C36.3061 27.148 36.9456 26.62 37.7272 26.392C38.0115 26.308 38.2957 26.26 38.5918 26.26ZM51.2992 32.488H47.0239L51.8085 25.36C51.9032 25.228 51.9032 25.048 51.8322 24.904C51.7611 24.76 51.6072 24.676 51.4532 24.676H45.3659C44.9633 24.676 44.6317 25.012 44.6317 25.42C44.6317 25.828 44.9633 26.164 45.3659 26.164H49.4399L44.6554 33.292C44.5606 33.424 44.5606 33.604 44.6317 33.748C44.7027 33.892 44.8567 33.976 45.0106 33.976H51.2992C51.7019 33.976 52.0335 33.64 52.0335 33.232C52.0335 32.824 51.7019 32.488 51.2992 32.488ZM60.7736 32.488H56.4983L61.2829 25.36C61.3776 25.228 61.3776 25.048 61.3065 24.904C61.2355 24.76 61.0815 24.676 60.9276 24.676H54.8403C54.4376 24.676 54.106 25.012 54.106 25.42C54.106 25.828 54.4376 26.164 54.8403 26.164H58.9261L54.1416 33.292C54.0468 33.424 54.0468 33.604 54.1179 33.748C54.1889 33.892 54.3429 33.976 54.4968 33.976H60.7854C61.1881 33.976 61.5197 33.64 61.5197 33.232C61.5079 32.824 61.1881 32.488 60.7736 32.488ZM65.0015 20.668C64.5989 20.668 64.2673 21.004 64.2673 21.412V33.268C64.2673 33.676 64.5989 34.012 65.0015 34.012C65.4042 34.012 65.7358 33.676 65.7358 33.268V21.412C65.7358 20.992 65.4042 20.668 65.0015 20.668ZM77.0221 28.036C76.9037 27.604 76.7142 27.196 76.4774 26.824C76.0629 26.176 75.4944 25.636 74.8193 25.264C73.7535 24.676 72.4863 24.544 71.3257 24.88C70.1414 25.228 69.1703 26.02 68.59 27.112C67.9978 28.204 67.8675 29.452 68.211 30.64V30.652C68.2939 30.916 68.4123 31.252 68.4123 31.264C68.8031 32.188 69.4545 32.896 70.4138 33.424C71.0888 33.796 71.8468 34 72.6047 34C73.0429 34 73.4811 33.94 73.9074 33.808C74.8075 33.544 75.5891 33.016 76.1813 32.284L76.2168 32.236C76.3708 32.044 76.501 31.84 76.6195 31.624C76.8326 31.24 76.6905 30.76 76.3234 30.544C76.205 30.484 76.0747 30.448 75.9444 30.448C75.6602 30.448 75.3996 30.604 75.2575 30.856C75.068 31.204 74.8075 31.516 74.4996 31.756C74.4759 31.78 74.4522 31.804 74.4285 31.816C74.1443 32.032 73.8127 32.2 73.4692 32.296C72.6995 32.524 71.8704 32.428 71.1599 32.044C70.698 31.792 70.3072 31.408 70.0229 30.94L76.4892 29.02C76.9037 28.888 77.1406 28.444 77.0221 28.036ZM72.6166 26.26C73.114 26.26 73.6232 26.392 74.0614 26.632C74.4996 26.872 74.8786 27.232 75.1628 27.664C75.1746 27.688 75.1983 27.712 75.2102 27.736L69.5729 29.416C69.5611 28.876 69.6913 28.336 69.94 27.868C70.3309 27.148 70.9704 26.62 71.752 26.392C72.0362 26.308 72.3323 26.26 72.6166 26.26ZM31.711 29.848C31.4978 29.524 31.1781 29.26 30.7754 29.044C30.1241 28.708 29.2714 28.552 28.4542 28.42L28.3239 28.396C27.7555 28.3 27.1633 28.216 26.7843 28.012C26.5001 27.868 26.3935 27.7 26.3935 27.376C26.3935 26.752 27.0686 26.272 27.9568 26.272C29.0227 26.272 29.6148 26.584 30.2899 27.004C30.4083 27.076 30.5504 27.124 30.7044 27.124C30.9768 27.124 31.2373 26.98 31.3794 26.74C31.486 26.56 31.5215 26.344 31.4742 26.14C31.4268 25.936 31.2965 25.756 31.1189 25.648C30.7517 25.42 30.3491 25.18 29.8398 25C29.2714 24.796 28.6555 24.688 27.9686 24.688C27.1515 24.688 26.3817 24.94 25.8014 25.396C25.1737 25.9 24.8184 26.608 24.8184 27.388C24.8184 28.312 25.2566 29.032 26.0738 29.452C26.6778 29.764 27.4002 29.872 28.0871 29.98L28.2173 30.004C29.9938 30.292 30.5149 30.544 30.5149 31.132C30.5149 31.876 29.7806 32.356 28.6555 32.368H28.6082C27.4002 32.368 26.7133 31.9 26.3462 31.648C26.2869 31.612 26.2396 31.564 26.1804 31.54C26.0501 31.456 25.908 31.42 25.7659 31.42C25.4935 31.42 25.2448 31.564 25.0908 31.792C24.8658 32.164 24.9724 32.656 25.3395 32.896C25.3632 32.908 25.3869 32.932 25.4224 32.956L25.4461 32.968C25.8843 33.268 26.8909 33.976 28.5963 33.976H28.6555C29.6385 33.964 30.4793 33.7 31.0952 33.208C31.7347 32.692 32.0781 31.96 32.0781 31.156C32.09 30.652 31.9597 30.22 31.711 29.848Z",
          fill: "#382757"
        }
      ),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint0_linear_647_1977",
            x1: 12.8405,
            y1: 31.2777,
            x2: 9.90814,
            y2: 27.8288,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#CE5DCB" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.2095, stopColor: "#C558CC" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.5525, stopColor: "#AC4ACF" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.9845, stopColor: "#8534D4" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#8333D4" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint1_linear_647_1977",
            x1: 12.945,
            y1: 27.3093,
            x2: 19.1496,
            y2: 27.3093,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { offset: 0.0237, stopColor: "#FF5667" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.6592, stopColor: "#FC8B82" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FBA28E" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint2_linear_647_1977",
            x1: 5.99786,
            y1: 25.0496,
            x2: 14.5369,
            y2: 25.0496,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#00B874" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.5126, stopColor: "#29D3A2" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.6817, stopColor: "#53DFB6" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#9FF4D9" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint3_linear_647_1977",
            x1: 11.8167,
            y1: 30.9456,
            x2: 20.3557,
            y2: 30.9456,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#FCD77E" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.5241, stopColor: "#FEA500" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FF5B00" })
            ]
          }
        )
      ] })
    ]
  }
);
const VpPaymentSezzleAsset = forwardRef(PaymentSezzleAsset);

export { VpPaymentSezzleAsset as default };
